import React from 'react';
import { useNavigate , useParams } from 'react-router-dom';
import { signOut } from 'firebase/auth';
import { auth } from '../firebase';
import Button from 'react-bootstrap/Button';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import NavBar from '../Components/NavBar';

const MenuPage = () => {
    const { teamName } = useParams();
    const navigate = useNavigate();
    
    const handleLogout = async () => {
        try {
            await signOut(auth);
            localStorage.removeItem('currentTeam');
            navigate('/');
        } catch (error) {
            // Handle logout error if needed
        }
    };
    
    return (
        <>
            <NavBar pageName="Menu" showMenu={false}/>
            <Container id="menuContainer" className='mx-0'>
                <Row className='text-center' xs={1}>
                    <Col className="pb-3 d-grid" lg={4}>
                        <Button onClick={() => navigate(`/new-game/${teamName}`)}>Record Game</Button>
                    </Col>
                    <Col className="pb-3 d-grid" lg={4}>
                        <Button onClick={() => navigate(`/manage-team/${teamName}`)}>Manage Team</Button>
                    </Col>
                    <Col className="pb-3 d-grid" lg={4}>
                        <Button onClick={() => navigate(`/player-stats/${teamName}`)}>Player Stats</Button>
                    </Col>
                    <Col className="pb-3 d-grid" lg={4}>
                        <Button onClick={() => navigate(`/team-stats/${teamName}`)}>Team Stats</Button>
                    </Col>
                    <Col className="pb-3 d-grid warning" lg={4}>
                        <Button onClick={handleLogout}>Log Out</Button>
                    </Col>
                </Row>
            </Container>
        </>
    );
};

export default MenuPage;
